

















































import {UtilitiesFunctions} from "@/helpers";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import formRules from "../helpers/formRules";
import { mapGetters } from 'vuex';
import moment from 'moment';

@Component({
  computed: mapGetters['menu']
})
export default class CustomDatePicker extends Vue {
  date: any = [];
  menu: boolean = false;

  month: string = null;
  disableSelection = false;
  tmpDate: any;
  selectedMonth: string = null;
  myRules = {
    mandatory: formRules.mandatoryDate
  };

  @Prop({ default: false }) private loading!: boolean;
  @Prop({default: ""}) private label!: string;
  @Prop({default: null}) private dateSet!: string | [];
  @Prop({default: ""}) private min: any;
  @Prop({default: ""}) private id!: string;
  @Prop({default: null}) private pickerIndex!: number;
  @Prop({default: false}) private required!: boolean;
  @Prop({default: false}) private readonly!: boolean;
  @Prop({default: false}) private birthday!: boolean;
  @Prop({
    default: () => []
  }) private textFieldRules: any;
  @Prop({
    default: () => []
  }) private allowedDates!: any;
  @Prop({default: false}) private range!: boolean;


  @Watch("dateSet", {immediate: true, deep: true})
  onDateSetChanged(val: string) {
    this.disableSelection = !!val;
    this.tmpDate = UtilitiesFunctions.dateFormatter(this.dateSet);
  }

  @Watch("menu", {immediate: true, deep: true})
  onMenuChanged(v: string) {
    if (!v) this.selectedMonth = null;
  }

  getTomorrow() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString();
  }

  mounted() {
    this.date = (this.range) ? [] : this.dateSet;
    this.min = (!this.min || (this.min && this.min === '')) ? this.getTomorrow() : this.min;
    this.textFieldRules = (this.textFieldRules) ? this.textFieldRules : this.myRules.mandatory;
    this.tmpDate = UtilitiesFunctions.dateFormatter(this.dateSet) || "";
  }

  isDayAllowed = (v: any) => {
    console.log(v);
    return true;
  }

  pickerDateWololo = (v: any) => {
    this.monthSelected(v);
}

  isMonthAllowed = (v: string) => {
    const [queriedYear, queriedMonth] = v.split('-').map(n => parseInt(n)),
          now = moment(),
          currentYear = now.year(),
          currentMonth = (now.month() + 1);

    if (queriedYear > currentYear) return true;
    else return queriedMonth >= currentMonth;
  }

  monthSelected(date: string) {
    this.selectedMonth = date;
    this.$emit("monthSelect", this.id, this.selectedMonth, this.pickerIndex);
  }

  save(date: string) {
    if (this.range) {
      this.date = this.date.sort();
      const formattedRange = [];
      for (let i = 0; i < this.date.length; i++) {
        formattedRange.push(UtilitiesFunctions.dateFormatter(this.date[i]));
      }
      this.tmpDate = formattedRange.join(' ~ ');
    } else {
      this.menu = false;
      this.date = date;
      this.tmpDate = UtilitiesFunctions.dateFormatter(date) || "";
    }
    this.$emit("updateDate", this.id, this.date, this.pickerIndex);
  }

  clear() {
    this.tmpDate = this.date = "";
    this.$emit("updateDate", this.id, this.tmpDate, this.pickerIndex);
    this.$emit("clearDate");
  }
}
